import { Box, Chip, Typography } from '@mui/material';
import { branchLabel } from './agentManagerUtils';

// Agent email (from Priority AGENTS) — where the approve/reject email goes.
export const AgentEmail = ({ email }) =>
  email ? (
    <Typography variant="caption" color="text.secondary" dir="ltr">
      {email}
    </Typography>
  ) : null;

export const AgentBranchChips = ({ branches, branchNames }) =>
  branches?.length ? (
    <Box display="flex" flexWrap="wrap" gap={0.5}>
      {branches.map((b) => (
        <Chip key={b} label={branchLabel(b, branchNames)} size="small" sx={{ bgcolor: '#e8f0fe', color: '#0054A5' }} />
      ))}
    </Box>
  ) : (
    <Chip label="כל הסניפים" size="small" variant="outlined" sx={{ color: '#0054A5', borderColor: '#0054A5' }} />
  );
